<!-- src/components/GlobalDialog.vue -->
<template>
  <v-dialog
    :model-value="store.open"
    @update:model-value="value => { if (!value) store._onEsc(); }"
    :persistent="store.persistent"
    max-width="480"
  >
    <v-card class="rounded-xl">
      <v-card-title class="py-4">
        <div class="flex items-center gap-3">
          <v-avatar size="42" :color="tone.color" variant="tonal">
            <v-icon :icon="tone.icon" size="22" />
          </v-avatar>
          <span class="text-h6">{{ store.title }}</span>
        </div>
      </v-card-title>

      <v-card-text class="pb-0">
        <div class="text-body-2 whitespace-pre-line">
          {{ store.message }}
        </div>
      </v-card-text>

      <v-divider class="my-4" />

      <v-card-actions class="justify-end gap-2 pb-4 px-4">
        <template v-for="key in store.buttonList" :key="key">
          <v-btn
            :variant="key === store.primaryAction ? 'flat' : 'text'"
            :color="key === store.primaryAction ? tone.color : undefined"
            :autofocus="store.buttonList.includes('cancel') ? key === 'cancel' : key === store.primaryAction"
            @click="store._resolve(key)"
          >
            {{ key === 'ok' ? store.confirmLabel : labels[key] }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
// Minimal icon set using Vuetify's built-ins (or replace with your own).
import { computed, onMounted, onBeforeUnmount } from "vue"; // ✅ Add this
import { useDialogStore } from "@/stores/dialog";
const store = useDialogStore();
function onEscape(event) {
  if (event.key !== 'Escape' || !store.open) return;
  event.preventDefault(); event.stopImmediatePropagation(); store._onEsc();
}
onMounted(() => window.addEventListener('keydown', onEscape, true));
onBeforeUnmount(() => window.removeEventListener('keydown', onEscape, true));

const labels = {
  ok: "OK",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
};

const tone = computed(() => ({
  info: { color: 'primary', icon: 'mdi-information-outline' },
  success: { color: 'success', icon: 'mdi-check-circle-outline' },
  warn: { color: 'warning', icon: 'mdi-alert-outline' },
  error: { color: 'error', icon: 'mdi-alert-circle-outline' },
}[store.variant] || { color: 'primary', icon: 'mdi-information-outline' }));
</script>

<style scoped>
.flex { display: flex; }
.items-center { align-items: center; }
.gap-3 { gap: .75rem; }
.whitespace-pre-line { white-space: pre-line; }
.v-card { padding: 8px; }
.text-body-2 { line-height: 1.7; color: #526071; }
.v-card-actions { gap: 8px; }
.v-btn { min-width: 90px; }
</style>
